export const STANDARD_SIDEBAR = 'standard'
export const ICON_SIDEBAR = 'icon'
